import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const ModernSelect = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="modern-select-container" ref={containerRef}>
      <div 
        className="modern-select-trigger" 
        onClick={() => setIsOpen(!isOpen)}
        style={{ borderColor: isOpen ? '#8E24AA' : '' }}
      >
        <span>{value || placeholder}</span>
        <FiChevronDown className={`dropdown-chevron ${isOpen ? 'open' : ''}`} />
      </div>

      {isOpen && (
        <div className="modern-select-options">
          {options.map((opt) => (
            <div
              key={opt}
              className={`modern-option ${value === opt ? 'selected' : ''}`}
              onClick={() => {
                onChange(opt);
                setIsOpen(false);
              }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ModernSelect;